<div id="notfound">
<div class="notfound">
<div class="notfound-bg">
<div></div>
<div></div>
<div></div>
</div>
<h1>CONGRATS!</h1>
<h2>{{status}}</h2>
<a [routerLink]="['/']">go back</a>
&nbsp;
<a [routerLink]="['/voterreg']">Register as Voter</a>
<div class="notfound-social">
	Please report in the Whatspp or Telegram Group<br><br>
<a href="#"><i class="fa fa-whatsapp"></i></a>
<a href="#"><i class="fa fa-telegram"></i></a>
</div>
</div>
</div>